import { useDispatch } from 'react-redux';

import { updateInventoryNavigation } from '@atom/actions/inventoryNavigationActions';
import { SearchParamType, useNavigation } from '@atom/hooks/useNavigation';
import { AssetSidebar } from '@atom/map';

import { State } from '../InventoryPortal';

import classes from './inventoryAssetSidebar.module.css';

type InventoryAssetSidebarProps = {
  portalState: State;
};

const InventoryAssetSidebar = ({ portalState }: InventoryAssetSidebarProps) => {
  const dispatch = useDispatch();
  const [{ id }, { updateSearchParams, navigate }] = useNavigation({
    id: SearchParamType.STRING,
  });

  const handleClose = () => updateSearchParams({ id: '' });

  const handleViewDetail = () => {
    dispatch(updateInventoryNavigation(portalState));
    navigate(`/inventory/${id}`);
  };

  return (
    <div className={classes.container}>
      <AssetSidebar
        id={id}
        onClose={handleClose}
        onViewDetail={handleViewDetail}
      />
    </div>
  );
};

export default InventoryAssetSidebar;
